import { Checkbox, Grid } from '@mui/material';
import { first } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { IProduct } from 'src/interfaces';
import { getProductNameFromAssetId } from 'src/utils/gcf-helper';

import { CheckboxLabel } from './EditProductCategoryPage.styled';

interface ProductCardProps {
  product: IProduct;
  assets: any[];
  isSelected: boolean;
  onToggle: (product: IProduct) => void;
}

export const ProductCard = React.memo(
  ({ product, assets, isSelected, onToggle }: ProductCardProps) => {
    const productName = useMemo(() => {
      return (
        product.name_override ||
        product.productVariations.find(
          (variation) => variation.product_code === product.product_code,
        )?.name ||
        getProductNameFromAssetId(assets, first(product.asset_id)) ||
        product.product_name
      );
    }, [product, assets]);

    const handleToggle = useCallback(() => {
      onToggle(product);
    }, [product, onToggle]);

    return (
      <Grid item xs={12} sm={6} md={4} lg={3} key={product.product_code}>
        <CheckboxLabel
          label={productName}
          control={<Checkbox checked={isSelected} onChange={handleToggle} />}
        />
      </Grid>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.product.product_code === nextProps.product.product_code &&
      prevProps.isSelected === nextProps.isSelected &&
      prevProps.assets === nextProps.assets &&
      prevProps.onToggle === nextProps.onToggle
    );
  },
);

ProductCard.displayName = 'ProductCard';
